import { getYear } from 'date-fns';

export const startYear = 2019;
export const endYear = getYear(new Date()) + 10;
